module.exports = __webpack_public_path__ + "static/img/money.13cca8f6.png";